import { descriptorPropTypes } from "lib/common/descriptorcontrols/formhelpers";
import EntityProxy from "data/util/EntityProxy";
import entityMetaStore from "data/meta/entityMetaStore";
import React from "react";
import PropTypes from "prop-types";
import RecordGridDataGateway, {
    buildColumnsFromConfig,
    buildCreatable,
    buildDevicelesiongridCheckboxColumns,
} from "../RecordGridDataGateway";

import Control
    from "lib/common/descriptorcontrols/CompositionField/devicelesiongrid";

export class CompositionFielddevicelesiongrid extends React.Component {
    render() {
        const {
            descriptor,
            fluxContext,
            activeRecord,
            onFocus,
            onBlur,
            onKeyDown,
        } = this.props;
        const config = descriptor.config;

        const creatables = [];
        for (let i = 0, l = config.creatables.length; i < l; i++) {
            const creatable = config.creatables[i];
            const ei = entityMetaStore.getInfo(creatable.key);
            creatables.push(buildCreatable(ei.implKey, creatable.name, creatable.key, creatable.collectionKey, activeRecord));
        }

        const columns = buildColumnsFromConfig(config.columns, this.props)
            .concat(
                buildDevicelesiongridCheckboxColumns(
                    this.props, null
                )
            );
        return (
            <RecordGridDataGateway
                key={descriptor.key}
                enabled={activeRecord.isFieldEnabled(descriptor.key)}
                component={Control}
                activeRecord={activeRecord}
                shortname={config.rowSourceEntityFieldKey}
                singularLabel={config.otherEntityName}
                fluxContext={fluxContext}
                descriptor={descriptor}
                addMode={config.addMode}
                allowView={!config.inline}
                allowCreate={true}
                allowRemove={true}
                columns={columns}
                creatables={creatables}
                onFocus={onFocus}
                onBlur={onBlur}
                onKeyDown={onKeyDown}
            />
        );
    }
}

CompositionFielddevicelesiongrid.propTypes = {
    descriptor: PropTypes.shape(descriptorPropTypes({
        inline: PropTypes.bool,
        otherEntityName: PropTypes.string.isRequired,
        rowSourceEntityFieldKey: PropTypes.string.isRequired,
        rowSourceEntityCollectionKey: PropTypes.string.isRequired,
        addMode: PropTypes.string.isRequired,
        columns: PropTypes.arrayOf(PropTypes.shape({
            heading: PropTypes.string.isRequired,
            width: PropTypes.oneOfType([
                PropTypes.string,
                PropTypes.number,
            ]).isRequired,
            type: PropTypes.string.isRequired,
            script: PropTypes.string,
            itemInfo: PropTypes.object,
        })).isRequired,
        creatables: PropTypes.arrayOf(PropTypes.shape({
            name: PropTypes.string.isRequired,
            key: PropTypes.string.isRequired,
            collectionKey: PropTypes.string.isRequired,
        })).isRequired,
    })),
    fluxContext: PropTypes.string.isRequired,
    activeRecord: PropTypes.instanceOf(EntityProxy).isRequired,
    onFocus: PropTypes.func.isRequired,
    onBlur: PropTypes.func.isRequired,
    onKeyDown: PropTypes.func.isRequired,
};

export default CompositionFielddevicelesiongrid;



// WEBPACK FOOTER //
// ./app/lib/dataentry/lib/dataentryform/formitems/CompositionField/devicelesiongrid.js